import { ACTIONS, Can, SUBJECTS } from '../../../../../Permission'
import { Button, BUTTON_TYPES } from '../../../../../../components/Button'
import { BTN_TXT } from '../../../../../../constants'
import { useRFPDetailsPopupContext } from '../../../../RFPDetails/Providers/RFPDetailsPopupProvider'
import { subject } from '@casl/ability'
import { useRFPDetailsContext } from '../../../../RFPDetails/Providers/RFPDetailsContextProvider'

export const EditSurveyFromHospitalUser = () => {
  const { submitSurveyPopup } = useRFPDetailsPopupContext()
  const rfpDetailsContext = useRFPDetailsContext()

  const { data } = rfpDetailsContext.state
  return (
    <Can I={ACTIONS.VOTE} a={subject(SUBJECTS.SURVEY, { ...data })}>
      <Button
        type={BUTTON_TYPES.LINK}
        onClick={() => submitSurveyPopup.actions.open()}
        upperCase
      >
        {BTN_TXT.EDIT_SURVEY}
      </Button>
    </Can>
  )
}
